module.exports = function(bootstrap) {
	bootstrap.directive('validation', ["$state", "$location", "$urlRouter", "$urlMatcherFactory", function($state, $location, $urlRouter, $urlMatcherFactory) {
		return {
			replace: true,
			transclude: true,
			scope: {
				"validation": "=",
				"form": "="
			},
			template:	'<div class="validationErrorContainer" data-ng-show="validation.$invalid && (validation.$touched || form.$submitted || form.$$parentForm.$submitted)" ' +
								'data-ng-messages="validation.$error">'+
							'<div class="redArrowUp"></div><div class="whiteArrowUp"></div><div class="hm-icon icon-alert validationIcon"></div><div class="validationMessage" data-ng-transclude></div>'+
						'</div>'
		};
	}]);
};